import { Component, input, model } from '@angular/core';
import { OrderPosition } from 'src/app/common/OrderPosition';
import { OrderPositionStatusConstants } from '../../common/OrderPositionStatus';
import { OrderPositionStatusDisplayNamePipe } from '../../pipes/order-position-status.pipe';

/**
 * One position of a purchase: image, name, quantity, description — and its status once it is no
 * longer simply bought. Read-only in the purchase list; with `claimable` on the order detail
 * page, where a bought position can be ticked for a cancellation request. (#199: the two were
 * copies, and the detail page's copy had lost the measurements in the stylesheet.)
 */
@Component({
  selector: 'app-order-group-order-position-item',
  imports: [OrderPositionStatusDisplayNamePipe],
  templateUrl: './order-group-order-position-item.component.html',
  styleUrls: ['./order-group-order-position-item.component.css'],
})
export class OrderGroupOrderPositionItemComponent {
  readonly orderPosition = input<OrderPosition>();
  /** Offers the cancellation checkbox — on a position that is still simply bought. */
  readonly claimable = input(false);
  /** Ticked for the cancellation request; the order holds the selection. */
  readonly selected = model(false);

  /** Bought and nothing more: the only state a cancellation can be requested from. */
  get isBought(): boolean {
    return this.orderPosition()?.status === OrderPositionStatusConstants.PositionStatusIdDefault;
  }

  /** One per position — the label of every checkbox used to tick the first one. */
  get checkboxId(): string {
    return `claim-${this.orderPosition()?.id}`;
  }
}
